__turbopack_context__.v({
  "className": "jetbrains_mono_19544c54-module__IjNLGa__className",
  "variable": "jetbrains_mono_19544c54-module__IjNLGa__variable",
});
